import { render, staticRenderFns } from "./DriveCard.vue?vue&type=template&id=1c20ddce"
import script from "./DriveCard.vue?vue&type=script&lang=js"
export * from "./DriveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports